<div class="card" *ngIf="!!minubaSettings && !!minubaSettings.ordertypes && minubaSettings.ordertypes.length > 0">
  <div class="card-body" style="background-color: #EEEEEE;">
    <h5 class="card-title">MINUBA {{ 'Standard.CaseERPSettings' | translate }}</h5>
    <h6 class="card-subtitle mb-2 text-muted">{{ 'Standard.CaseERPSettingsSubText' | translate }}</h6>
    <!-- Minuba Casetype -->
    <div class="dataItem">
      <label class="dataItem-label" for="minubaCaseType">{{ 'Standard.CaseType' | translate }}</label>
      <select class="form-control form-control-sm form-control-erp" id="minubaCaseType" [(ngModel)]="data.minubaCaseType" (change)="updateParent()">
        <option [ngValue]="null">{{ 'Standard.Choose' | translate }}</option>
        <option *ngFor="let x of minubaSettings.ordertypes" [value]="x.id">{{ x.name }}</option>
      </select>
    </div>
  </div>
</div>